export {default} from './SectionTitle';
